/**
 * 결과 카드 organism(DoseReviewResultView) — styled.
 *
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 *
 * 테스트 패널 style.ts에서 결과 카드(ResultView)·원문 뷰(RawView)가 쓰던 18개를 승격(동작 불변).
 * 테스트 패널은 공용 4개(Card·InfoLine·Row·WarnText)를 여기서 import한다(방향: pages → organisms).
 */
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const WarnText = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Orange")?.[500] ?? COLOR_SYSTEM.get("Red")?.[400]};
  margin-top: 4px;
`;

export const NoticeLine = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
  background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
  border-radius: 8px;
  padding: 8px 10px;
`;

export const SummaryLine = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
`;

export const Card = styled.div<{ muted?: boolean }>`
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: ${(p) =>
    p.muted ? COLOR_SYSTEM.get("Gray")?.[50] : COLOR_SYSTEM.get("Gray")?.[0]};
`;

export const CardTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

/** 접이식 카드 헤더 — 클릭 토글(상세 화면 개편). 기본 뷰(테스트 패널)에선 쓰지 않는다. */
export const CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
`;

export const Chevron = styled.span`
  margin-left: auto;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
  font-size: 12px;
`;

/** 접힌 카드 본문 — CSS 접힘(마운트 유지 → 초안 보존). open이 아니면 숨긴다. */
export const CollapsibleBody = styled.div<{ $open: boolean }>`
  display: ${(p) => (p.$open ? "flex" : "none")};
  flex-direction: column;
  gap: 8px;
`;

export const CardTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[900]};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardSub = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
`;

export const BadgeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

export const FindingBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
  border-top: 1px dashed ${COLOR_SYSTEM.get("Gray")?.[100]};
`;

export const InfoLine = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
`;

export const DowngradeLine = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Red")?.[400]};
`;

export const Citation = styled.div<{ expanded?: boolean }>`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
  ${(p) =>
    p.expanded
      ? ""
      : `display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;`}
`;

export const GroupTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
  margin-top: 4px;
`;

export const DupBlock = styled.div`
  border: 1px solid ${COLOR_SYSTEM.get("Red")?.[100]};
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background-color: ${COLOR_SYSTEM.get("Red")?.[10]};
`;

export const RawWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RawBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const RawHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
`;

export const Pre = styled.pre`
  margin: 0;
  padding: 10px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 8px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 320px;
  overflow: auto;
`;
